<template>
  <div class="view backOffice">
    <div class="content">
      <div class="header">
        <div class="client-name">{{ $t('adminTitle') }}</div>
      </div>

      <div class="sub-header no-scroll-bar">
        <RouterLink class="link" :class="{ active: page.includes('account') }" to="/admin/account">{{ $t('manageAccounts') }}</RouterLink>
        <RouterLink class="link" :class="{ active: page.includes('package') }" to="/admin/package">{{ $t('managePackages') }}</RouterLink>
        <RouterLink class="link" :class="{ active: page.includes('article') }" to="/admin/article">{{ $t('manageArticles') }}</RouterLink>
        <RouterLink class="link" :class="{ active: page.includes('businessIntelligence') }" to="/admin/businessIntelligence">{{
          $t('businessIntelligence')
        }}</RouterLink>
      </div>

      <RouterView :key="'admin' + $route.fullPath"></RouterView>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
.view {
  padding: 144px 0 64px;
  box-sizing: border-box;

  .content {
    .header {
      display: flex;
      align-items: center;
      margin: 21px 0 0;

      .picture {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        color: colors.$black-color;
        background: colors.$white-color;
        margin: 0 32px 0 0;
        font-weight: 800;
        font-size: 28px;
      }

      .client-name {
        color: colors.$darkblue-color;
        font-weight: 500;
        font-size: 25px;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .content {
    width: 100%;
    overflow: hidden;

    .sub-header {
      display: flex;
      align-items: center;
      padding: 0;
      overflow-x: auto;

      .link {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        min-width: 250px;
        margin: 0;
      }
    }
  }
}
</style>
